
















import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import { groupTrendSynthEZDistributeScoreType } from '@/api/teachingProtection/assessment'
import BasePanel from '@/components/BasePanel/index.vue'
import BarDashedLine from '../../../_components/charts/BarDashedLine.vue'
import BarDashed from '../../../_components/charts/BarDashed.vue'

  @Component({
    components: {
      BasePanel,
      BarDashedLine,
      BarDashed
    }
  })
export default class extends Vue {
    @Prop() private params!: object

    private dataLength: number = 0

    private frirstChartData: any = {}
    private barDataArray: Array < object > = []
    private colorList: any = ['#F87A52', '#FFA100', '#6DD400', '#3A91FF', '#A35DFF']
    created() {
      if (!(this as any).$route.query.searchParams) return
      console.info(this.params)
      let params = this.params
      // params.compareIds = [params.compareIds[0]]
      groupTrendSynthEZDistributeScoreType(params).then(res => {
        if (res.data.synthEZDistributeScoreType) {
          this.dataLength = res.data.synthEZDistributeScoreType.details.length
          this.frirstChartData = res.data.synthEZDistributeScoreType
        }

        this.barDataArray = res.data.barChart || []
      })
    }
}
